<template>
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0" style="width: 100px">#</th>
        <th scope="col" class="text-left border-0">Titulo</th>
        <th scope="col" class="border-0">Status</th>
        <th scope="col" class="border-0">Aberto em</th>
        <th scope="col" class="border-0">Fechado em</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(ticket, index) in tickets" :key="index">
        <td :class="['border-color', 'border-color-'+ ticket.status_slug]">{{ ticket.id }}</td>
        <td class="text-left link">
          <d-link :to="{ name: 'admin-ticket-edit', params: { ticketId: ticket.id }}">{{ ticket.title }}</d-link>
        </td>
        <td :class="['color-'+ticket.status_slug]">{{ ticket.status }}</td>
        <td>{{ ticket.opened }}</td>
        <td>{{ ticket.closed }}</td>
      </tr>
      <tr v-if="tickets.length === 0">
        <td colspan="8" class="no-content">Ainda não foi cadastrado nenhum chamado.</td>
      </tr>
    </tbody>
  </table>
</template>

<script>

export default {
  name: 'ticket-table-client-list',
  props: {
    tickets: {
      type: Array,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    setStopwacth() {
      this.tickets.map(ticket => {
        ticket.stopwatch = null;
        if (ticket.status_slug !== 'closed') {
          this.stopwatch(ticket);
        }
        return ticket;
      });
    },
    stopwatch(ticket) {
      const created = new Date(ticket.updated_at);

      let seconds = Math.floor((new Date() - created) / 1000);
      let minutes = Math.floor(seconds / 60);
      let hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);

      hours -= (days * 24);
      minutes = minutes - (days * 24 * 60) - (hours * 60);
      if (minutes < 10) { minutes = `0${minutes}`; }
      if (hours < 10) { hours = `0${hours}`; }
      seconds = seconds - (days * 24 * 60 * 60) - (hours * 60 * 60) - (minutes * 60);
      ticket.stopwatch = `${days}d ${hours}:${minutes}:${seconds}`;
    },
  },
  mounted() {
    setInterval(() => {
      this.setStopwacth();
    }, 1000);
  },
};
</script>
<style lang="scss" scoped>
@import '~_scss/overrides';

$size: 5px;
.border-color {
  border-left: $size solid $red;
  &-new {
    border-left-color: $red;
  }
  &-open {
    border-left-color: $orange;
  }
  &-progress {
    border-left-color: $yellow;
  }
  &-resolved {
    border-left-color: $green;
  }
  &-closed {
    border-left-color: $blue;
  }
}

.color{
  &-new {
    color: $red;
  }
  &-open {
    color: $orange;
  }
  &-progress {
    color: $yellow;
  }
  &-resolved {
    color: $green;
  }
  &-closed {
    color: $blue;
  }
}
.td-3 {
  width: 120px;
}
</style>
